var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"dialog",model:{value:(_vm.modalVisibility),callback:function ($$v) {_vm.modalVisibility=$$v},expression:"modalVisibility"}},[_c('syntax-highlighter',{attrs:{"data":_vm.changelog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }